export const isArchivedTeamInbox = inbox =>
  Boolean(inbox.additional_attributes?.archived_at) ||
  /^\s*\[ARQUIVADA\]/i.test(inbox.name || '');

export const visibleTeamInboxes = (inboxes = []) =>
  inboxes.filter(inbox => !isArchivedTeamInbox(inbox));

export const teamInboxStatus = inbox => {
  const status = String(inbox.additional_attributes?.connection_status || '')
    .trim()
    .toLowerCase();
  if (status === 'connected') return 'connected';
  if (status === 'connecting') return 'connecting';
  if (
    [
      'disconnected',
      'closed',
      'close',
      'failed',
      'logout',
      'logged_out',
      'unauthenticated',
    ].includes(status)
  ) {
    return 'disconnected';
  }
  return ['Channel::Api', 'Channel::Whatsapp'].includes(inbox.channel_type)
    ? 'unknown'
    : 'linked';
};
